module.exports = __webpack_public_path__ + "static/media/Expected_Outcomes.0a611f0d.jpg";